import { useEffect, useState } from "react";
import { HardDrive } from "lucide-react";
import api from "@/lib/api";
import { MB } from "@/lib/codaCaricamenti";

export default function SpazioArchivioCard() {
  const [d, setD] = useState(null);
  const [m, setM] = useState(null);
  const [tutti, setTutti] = useState(false);
  useEffect(() => { api.get("/archivio/spazio").then((r) => setD(r.data)).catch(() => {}); api.get("/archivio/migra-b2").then((r) => setM(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const pieni = d.immobili.filter((i) => i.byte > 0 && i.titolo !== "Immobile eliminato");
  const lista = tutti ? pieni : pieni.slice(0, 10);
  return (
    <div className="card-immo p-5" data-testid="spazio-archivio-card">
      <div className="flex items-center gap-2 mb-3"><HardDrive size={16} /><h3 className="font-display font-extrabold">Spazio archivio documenti</h3></div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-4">
        <div><div className="text-[11px] text-[var(--muted)]">Totale usato</div><div data-testid="spazio-totale" className="text-xl font-extrabold">{MB(d.totale_byte)}</div><div className="text-[11px] text-[var(--muted)]">{d.file} file</div></div>
        <div><div className="text-[11px] text-[var(--muted)]">Su Backblaze B2</div><div data-testid="spazio-b2" className="font-bold">{MB(d.b2_byte)}</div></div>
        <div><div className="text-[11px] text-[var(--muted)]">Su archivio Emergent (file precedenti)</div><div data-testid="spazio-emergent" className="font-bold">{MB(d.emergent_byte)}</div></div>
      </div>
      {m && m.stato !== "mai" && (
        <div data-testid="migrazione-b2-stato" className="text-xs mb-3 rounded-lg bg-slate-50 px-3 py-2">
          <div className="font-semibold">Spostamento file storici su Backblaze: {m.stato === "fatto" ? "completato" : m.stato === "errore" ? "fermo per un errore" : "in corso, a piccoli gruppi solo tra le 20:00 e le 7:00"}</div>
          <div><span data-testid="migrazione-b2-spostati">{m.spostati ?? 0} file spostati</span> · <span data-testid="migrazione-b2-mancanti">{m.da_spostare ?? 0} da spostare</span>{m.falliti?.length ? ` · ${m.falliti.length} non riusciti` : ""}</div>
          {m.stato === "errore" && m.errore && <div className="text-red-600">{m.errore}</div>}
        </div>
      )}
      <div className="text-xs font-bold text-slate-600 mb-1.5">Per immobile</div>
      <div className="divide-y divide-[var(--border)]">
        {lista.map((i) => (
          <div key={i.id} data-testid={`spazio-imm-${i.id}`} className="flex items-center gap-2 py-1.5 text-sm">
            <span className="flex-1 truncate">{i.titolo}</span><span className="text-xs text-[var(--muted)]">{i.file} file</span><span className="mono font-semibold w-20 text-right">{MB(i.byte)}</span>
          </div>
        ))}
        {!lista.length && <div className="text-sm text-[var(--muted)] py-2">Nessun file caricato.</div>}
      </div>
      {pieni.length > 10 && <button data-testid="spazio-mostra-tutti" onClick={() => setTutti(!tutti)} className="mt-2 text-xs font-semibold underline">{tutti ? "Mostra meno" : `Mostra tutti (${pieni.length})`}</button>}
    </div>
  );
}
